export const SET_PROJECT_TAGS = 'SET_PROJECT_TAGS';
export const ADD_PROJECT_TAG = 'ADD_PROJECT_TAG';
